<template>
  <div class="box">
    <van-icon class="iconBack" @click="goBack" name="arrow-up" />
    <video
      v-if="status"
      playsinline="true"
      webkitPlaysinline="true"
      id="myVideo"
      class="video-js vjs-default-skin vjs-big-play-centered"
      :style="changecss"
      controls
      preload="auto"
      :poster="poster"
      disablePictureInPicture
    ></video>
    <div class="tips" v-if="tips">
      <p>{{ msg }}</p>
      <div class="btnItem">
        <a href="tel:400-012-1121" class="callTel"> 联系客服 </a>
        <button class="btnFresh" @click="fresh()" v-if="videoInfo.low_live_url">
          点击刷新
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import appUtil from "@/utils/appUtil";
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      status: false,
      videoPlayer: null,
      poster:
        "https://static1.izhikang.com/webresource/usertech-public/app/image/videoPoster.png",
      changecss: {},
      width: "",
      height: "",
      onLine: navigator.onLine,
      tips: false,
      msg: "抱歉，播放失败",
      videoInfo: {},
      timer: null, //5分钟循环调用接口
      reloadTimes: 0,
    };
  },
  created() {
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    if (this.onLine) {
      this.changeLoading(true);
      this.width = document.documentElement.clientWidth;
      this.height = document.documentElement.clientHeight;
      this.changecss = {
        marginTop: -this.width / 2 + "px",
        marginLeft: -this.height / 2 + "px",
        height: this.width + "px",
        width: this.height + "px",
        maxWidth: this.height + "px",
      };
      this.getDetailTime();
    } else {
      this.goBack();
    }
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
      this.timer = null;
    });
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    goBack() {
      window.dhsdk.finishInterface();
    },
    getDetailTime() {
      // 获取页面m3u8
      const { course_id } = this.$route.query;
      if (course_id) {
        this.$api.classes
          .getOversee({
            course_id,
          })
          .then((res) => {
            this.changeLoading(false);
            if (res.error_code == 0) {
              this.status = true;
              this.videoInfo = res.result;
              this.$nextTick(() => {
                this.getVideo();
              });
            } else {
              this.msg = res.message;
              this.tips = true;
            }
          });
      }
    },
    getVideo() {
      let that = this;
      this.videoPlayer = videojs(
        "myVideo",
        {
          autoplay: false,
          muted: false,
          width: this.height,
          height: this.width,
          fluid: true,
          controls: true,
          languages: "zh-CN",
          controlBar: {
            timeDivider: false,
            durationDisplay: false,
            remainingTimeDisplay: false,
            currentTimeDisplay: false, // 当前时间
            volumeControl: false, // 声音控制键
            playToggle: true, // 暂停和播放键
            progressControl: false, // 进度条
            fullscreenToggle: false, // 全屏按钮
          },
          techOrder: ["html5"],
          sources: [
            {
              type: "application/x-mpegURL", // m3u8/Hls 的视频流类型
              src: this.videoInfo.low_live_url, // 对应播放的m3u8 路径
            },
          ],
          notSupportedMessage: "请返回重新进入...",
        },
        function () {
          //视频准备好
          // var tryTimes = 0;
          this.on("loadedmetadata", function () {
            console.log("视频信息准备完毕");
            //判断视频是否卡住，卡主30s重新load视频
            that.timeBind();
          });

          var seekingTimes = 0;
          var waitingTimes = 0;
          //直播卡顿加载loading时候触发seeking
          this.on("seeking", function () {
            //正在去拿视频流的路上
            console.log("seeking", ++seekingTimes);
            // if (seekingTimes >= 30) {
            //   location.reload();
            // }
          });
          //直播拿到视频流重新播放时出发seeked
          this.on("seeked", function () {
            seekingTimes = 0;
            waitingTimes = 0;
            //已经拿到视频流,可以播放
            console.log("seeked");
          });
          //每次卡顿都会出发waiting
          this.on("waiting", function () {
            console.log("waiting", waitingTimes++);
          });
          this.on("ended", function () {
            console.log("ended");
          });
          this.on("progress", function () {
            console.log("progress ");
          });
        }
      );
      that.videoPlayer.on("error", function () {
        that.errorBind("播放异常，视频地址可能不存在");
        console.log("error", 1111);
        // if (error.code === 4) {
        //   //1.用户终止 2.网络错误 3.解码错误 4.URL无效
        // }
      });
    },
    timeBind() {
      this.reloadTimes = 0;
      this.timer = setInterval(() => {
        // 获取当前播放时间
        var curr = this.videoPlayer.currentTime();
        // 直播流缓存的最新帧
        var buffer = this.videoPlayer.buffered().end(0);
        // 计算延迟
        var delayTime = buffer - curr;
        if (delayTime < 1 || buffer == 0) {
          //重试加载直播流
          // that.videoPlayer.currentTime(Math.floor(curr) + 10000000);
          this.reloadTimes++;
          console.log("重新加载：", curr, buffer, this.reloadTimes);
          if (this.reloadTimes >= 10) {
            //location.reload();
            this.errorBind("播放异常，视频地址可能不存在");
          }
        } else {
          this.reloadTimes = 0;
        }
      }, 3000);
    },
    errorBind(msg) {
      this.msg = msg;
      this.tips = true;
      clearInterval(this.timer);
      this.timer = null;
      this.videoPlayer.dispose();
    },
    fresh() {
      if (this.onLine) {
        // this.$router.go(0);
        location.reload();
      }
    },
  },
  watch: {
    onLine(newVal) {
      if (!newVal) {
        this.errorBind("抱歉，播放失败");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    this.videoPlayer.dispose();
  },
};
</script>
<style scoped lang="scss">
.box {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #000;
  .tips {
    position: absolute;
    width: 220px;
    height: 140px;
    margin-top: -70px;
    margin-left: -110px;
    transform: rotate(90deg);
    text-align: center;
    color: #ffffff;
    top: 50%;
    left: 50%;
    background: rgba(0, 0, 0, 1);
    border-radius: 10px;
    p {
      padding: 20px 0;
    }
    .btnItem {
      padding: 10px;
      display: flex;
      justify-content: center;
      .callTel,
      .btnFresh {
        margin: 0 5px;
        width: 80px;
        height: 30px;
        background: #e02727;
        border-radius: 6px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
      }
      .callTel {
        border: 1px solid #fff;
        background: transparent;
      }
    }
  }
}
.iconBack {
  position: absolute;
  color: #ffffff;
  font-size: 24px;
  top: 50px;
  right: 22px;
  z-index: 9999;
}
#myVideo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: rotate(90deg);
}
video {
  top: 50% !important;
  left: 50% !important;
}
.vjs-has-started .vjs-control-bar {
  padding: 0 50px !important;
}
</style>
